import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/api';
import { Toaster } from './components/ui/sonner';
import { MainLayout } from './components/MainLayoutNew';
import { ThemeProvider } from './components/ThemeProvider';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import InstituicoesPage from './pages/InstituicoesPage';
import InstituicaoDetalhePage from './pages/InstituicaoDetalhePage';
import UtentesPage from './pages/UtentesPage';
import AlertasPage from './pages/AlertasPage';
import AvaliacoesPage from './pages/AvaliacoesPage';
import RecursosPage from './pages/RecursosPage';
import PriorizacaoPage from './pages/PriorizacaoPage';
import VoluntariadoPage from './pages/VoluntariadoPage';
import MatchingAnalyticsPage from './pages/MatchingAnalyticsPage';
import CampanhasPage from './pages/CampanhasPage';
import FormularioAtualizacaoPage from './pages/FormularioAtualizacaoPage';
import SendysIntegracaoPage from './pages/SendysIntegracaoPage';
import RelatoriosPage from './pages/RelatoriosPage';
import DocumentosPage from './pages/DocumentosPage';
import RGPDPage from './pages/RGPDPage';
import AdminPortalPage from './pages/AdminPortalPage';
import CandidaturasPage from './pages/CandidaturasPage';
import UtilizadoresPortalPage from './pages/admin/UtilizadoresPortalPage';
import ParceirosPage from './pages/admin/ParceirosPage';
import ValidacaoVoluntariosPage from './pages/admin/ValidacaoVoluntariosPage';
import GestaoMissoesPage from './pages/admin/GestaoMissoesPage';
import AuditLogPage from './pages/admin/AuditLogPage';
import GestaoUtilizadoresPage from './pages/admin/GestaoUtilizadoresPage';
import AnaliseInteligentePage from './pages/admin/AnaliseInteligentePage';
import CertificadosPage from './pages/CertificadosPage';
import RegistoNecessidadesPage from './pages/RegistoNecessidadesPage';
import ComparadorDistritosPage from './pages/ComparadorDistritosPage';
import WorkflowsPage from './pages/configuracoes/WorkflowsPage';
import ValenciasPage from './pages/configuracoes/ValenciasPage';
import ConfiguracaoDemografiaPage from './pages/admin/ConfiguracaoDemografiaPage';
// Visitare - Portal de Visitadores
import FormBuilderPage from './pages/admin/FormBuilderPage';
import GestaoVisitasPage from './pages/admin/GestaoVisitasPage';
import GestaoVisitadoresPage from './pages/admin/GestaoVisitadoresPage';
import GestaCertificadosPage from './pages/admin/GestaCertificadosPage';
import VisitareLoginPage from './pages/visitare/VisitareLoginPage';
import VisitareDashboardPage from './pages/visitare/VisitareDashboardPage';
import VisitaFormPage from './pages/visitare/VisitaFormPage';
import VisitareAlterarPasswordPage from './pages/visitare/VisitareAlterarPasswordPage';
// Configurações
import DefinicoesPage from './pages/configuracoes/DefinicoesPage';
// Portal Público
import PublicInstituicoesCertificadasPage from './pages/PublicInstituicoesCertificadasPage';
// Portal das Instituições
import PortalLoginPage from './pages/PortalLoginPage';
import PortalRegistarPage from './pages/PortalRegistarPage';
import PortalRecuperarPasswordPage from './pages/PortalRecuperarPasswordPage';
import PortalLayout, { PortalDashboardHome } from './pages/PortalDashboardPage';
import PortalInstituicaoPage from './pages/PortalInstituicaoPage';
import PortalValenciasPage from './pages/PortalValenciasPage';
import PortalPedidosPage from './pages/PortalPedidosPage';
import PortalDocumentosPage from './pages/PortalDocumentosPage';
import PortalRelatoriosPage from './pages/PortalRelatoriosPage';
import PortalAtualizacaoPage from './pages/PortalAtualizacaoPage';
import PortalMensagensPage from './pages/PortalMensagensPage';
import PortalVoluntariadoPage from './pages/PortalVoluntariadoPage';
import PortalAlterarPasswordPage from './pages/PortalAlterarPasswordPage';
import PortalNotificacoesPage from './pages/PortalNotificacoesPage';
// Portal Público
import PublicHomePage from './pages/PublicHomePage';
import PublicVoluntariadoPage from './pages/PublicVoluntariadoPage';
import PublicDadosAbertosPage from './pages/PublicDadosAbertosPage';
import PublicInstituicoesPage from './pages/public/PublicInstituicoesPage';
// Gestão de Doadores
import DoadoresListPage from './pages/doadores/DoadoresListPage';
import PropostasContactoPage from './pages/doadores/PropostasContactoPage';
import PropostaRevisaoPage from './pages/doadores/PropostaRevisaoPage';
import CampanhasDoadoresPage from './pages/doadores/CampanhasDoadoresPage';
import DoadoresAnalyticsPage from './pages/doadores/DoadoresAnalyticsPage';
// Portal Público Doadores
import QueroDoarPage from './pages/public/QueroDoarPage';
// Admin - Cron Jobs
import CronDoadoresPage from './pages/admin/CronDoadoresPage';
import EnriquecimentoPage from './pages/admin/EnriquecimentoPage';
// Relatórios Admin
import RelatorioStockDemografiaPage from './pages/admin/RelatorioStockDemografiaPage';
import RelatorioNecessidadesLocalizacaoPage from './pages/admin/RelatorioNecessidadesLocalizacaoPage';
import NotificacoesAdminPage from './pages/admin/NotificacoesAdminPage';
// Configurações - Listas
import ListasPage from './pages/configuracoes/ListasPage';
// Histórico de Acessos
import HistoricoAcessosPage from './pages/admin/HistoricoAcessosPage';
// Pedidos de Alteração de Dados
import PedidosAlteracaoPage from './pages/PedidosAlteracaoPage';
// Portal do Doador
import DoadorPortalLayout, { DoadorAuthProvider } from './pages/doador/DoadorPortalLayout';
import DoadorLoginPage from './pages/doador/DoadorLoginPage';
import DoadorDashboardPage from './pages/doador/DoadorDashboardPage';
import DoadorDoacoesPage from './pages/doador/DoadorDoacoesPage';
import DoadorCertificadosPage from './pages/doador/DoadorCertificadosPage';
import DoadorPontosPage from './pages/doador/DoadorPontosPage';
import DoadorPerfilPage from './pages/doador/DoadorPerfilPage';
import DoadorCampanhasPage from './pages/doador/DoadorCampanhasPage';
import DoadorAlterarPasswordPage from './pages/doador/DoadorAlterarPasswordPage';
import './index.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-12 h-12 border-3 border-slate-200 border-t-[#0066CC] rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-500">A carregar...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <MainLayout>{children}</MainLayout>;
};

// Public Route Component (redirects to dashboard if authenticated)
// NOTE: Portal routes use separate auth, so we exclude them from this check
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-12 h-12 border-3 border-slate-200 border-t-[#0066CC] rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

// App Routes
const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route 
        path="/login" 
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        } 
      />
      
      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/instituicoes"
        element={
          <ProtectedRoute>
            <InstituicoesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/instituicoes/:id"
        element={
          <ProtectedRoute>
            <InstituicaoDetalhePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/utentes"
        element={
          <ProtectedRoute>
            <UtentesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alertas"
        element={
          <ProtectedRoute>
            <AlertasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/avaliacoes"
        element={
          <ProtectedRoute>
            <AvaliacoesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recursos"
        element={
          <ProtectedRoute>
            <RecursosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recursos/necessidades"
        element={
          <ProtectedRoute>
            <RegistoNecessidadesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/priorizacao"
        element={
          <ProtectedRoute>
            <PriorizacaoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/voluntariado"
        element={
          <ProtectedRoute>
            <VoluntariadoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/matching-analytics"
        element={
          <ProtectedRoute>
            <MatchingAnalyticsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/campanhas"
        element={
          <ProtectedRoute>
            <CampanhasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sendys"
        element={
          <ProtectedRoute>
            <SendysIntegracaoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/relatorios"
        element={
          <ProtectedRoute>
            <RelatoriosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/comparador-distritos"
        element={
          <ProtectedRoute>
            <ComparadorDistritosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documentos"
        element={
          <ProtectedRoute>
            <DocumentosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rgpd"
        element={
          <ProtectedRoute>
            <RGPDPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gestao-pedidos"
        element={
          <ProtectedRoute>
            <AdminPortalPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/candidaturas"
        element={
          <ProtectedRoute>
            <CandidaturasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/validacao-alteracoes"
        element={
          <ProtectedRoute>
            <PedidosAlteracaoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/utilizadores-portal"
        element={
          <ProtectedRoute>
            <UtilizadoresPortalPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/historico-acessos"
        element={
          <ProtectedRoute>
            <HistoricoAcessosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuracoes/workflows"
        element={
          <ProtectedRoute>
            <WorkflowsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuracoes/valencias"
        element={
          <ProtectedRoute>
            <ValenciasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuracoes/demografia"
        element={
          <ProtectedRoute>
            <ConfiguracaoDemografiaPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuracoes/listas"
        element={
          <ProtectedRoute>
            <ListasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parceiros"
        element={
          <ProtectedRoute>
            <ParceirosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/validacao-voluntarios"
        element={
          <ProtectedRoute>
            <ValidacaoVoluntariosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/certificados"
        element={
          <ProtectedRoute>
            <CertificadosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/missoes"
        element={
          <ProtectedRoute>
            <GestaoMissoesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/audit-log"
        element={
          <ProtectedRoute>
            <AuditLogPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/utilizadores"
        element={
          <ProtectedRoute>
            <GestaoUtilizadoresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/analise-inteligente"
        element={
          <ProtectedRoute>
            <AnaliseInteligentePage />
          </ProtectedRoute>
        }
      />
      
      {/* ==================== RELATÓRIOS ADMIN ==================== */}
      <Route
        path="/admin/relatorios/stock-demografia"
        element={
          <ProtectedRoute>
            <RelatorioStockDemografiaPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/relatorios/necessidades-localizacao"
        element={
          <ProtectedRoute>
            <RelatorioNecessidadesLocalizacaoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/notificacoes"
        element={
          <ProtectedRoute>
            <NotificacoesAdminPage />
          </ProtectedRoute>
        }
      />
      
      {/* ==================== GESTÃO DE DOADORES ==================== */}
      <Route
        path="/doadores"
        element={
          <ProtectedRoute>
            <DoadoresListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/doadores/propostas"
        element={
          <ProtectedRoute>
            <PropostasContactoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/doadores/propostas/:id"
        element={
          <ProtectedRoute>
            <PropostaRevisaoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/doadores/campanhas"
        element={
          <ProtectedRoute>
            <CampanhasDoadoresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/doadores/analytics"
        element={
          <ProtectedRoute>
            <DoadoresAnalyticsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/cron-doadores"
        element={
          <ProtectedRoute>
            <CronDoadoresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/enriquecimento"
        element={
          <ProtectedRoute>
            <EnriquecimentoPage />
          </ProtectedRoute>
        }
      />
      
      {/* ==================== PORTAL PÚBLICO DOADORES ==================== */}
      <Route
        path="/quero-doar"
        element={<QueroDoarPage />}
      />
      
      {/* ==================== VISITARE - ADMIN ==================== */}
      <Route
        path="/visitare/form-builder"
        element={
          <ProtectedRoute>
            <FormBuilderPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/visitare/visitas"
        element={
          <ProtectedRoute>
            <GestaoVisitasPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/visitare/visitadores"
        element={
          <ProtectedRoute>
            <GestaoVisitadoresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/visitare/certificados"
        element={
          <ProtectedRoute>
            <GestaCertificadosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configuracoes/definicoes"
        element={
          <ProtectedRoute>
            <DefinicoesPage />
          </ProtectedRoute>
        }
      />
      
      {/* ==================== PORTAL DO DOADOR ==================== */}
      <Route path="/doador/login" element={<DoadorLoginPage />} />
      <Route path="/doador" element={
        <DoadorAuthProvider>
          <DoadorPortalLayout />
        </DoadorAuthProvider>
      }>
        <Route path="dashboard" element={<DoadorDashboardPage />} />
        <Route path="doacoes" element={<DoadorDoacoesPage />} />
        <Route path="certificados" element={<DoadorCertificadosPage />} />
        <Route path="campanhas" element={<DoadorCampanhasPage />} />
        <Route path="pontos" element={<DoadorPontosPage />} />
        <Route path="perfil" element={<DoadorPerfilPage />} />
        <Route path="alterar-password" element={<DoadorAlterarPasswordPage />} />
        <Route index element={<Navigate to="/doador/dashboard" replace />} />
      </Route>
      
      {/* ==================== VISITARE - PORTAL AUDITORES ==================== */}
      <Route path="/visitare/login" element={<VisitareLoginPage />} />
      <Route path="/visitare/alterar-password" element={<VisitareAlterarPasswordPage />} />
      <Route path="/visitare/dashboard" element={<VisitareDashboardPage />} />
      <Route path="/visitare/agenda" element={<VisitareDashboardPage />} />
      <Route path="/visitare/visita/:id" element={<VisitaFormPage />} />
      
      {/* ==================== PORTAL PÚBLICO ==================== */}
      <Route path="/publico" element={<PublicHomePage />} />
      <Route path="/publico/voluntariado" element={<PublicVoluntariadoPage />} />
      <Route path="/publico/dados-abertos" element={<PublicDadosAbertosPage />} />
      <Route path="/publico/instituicoes" element={<PublicInstituicoesPage />} />
      <Route path="/publico/certificadas" element={<PublicInstituicoesCertificadasPage />} />
      
      {/* Public route for update form */}
      <Route
        path="/atualizar/:linkUnico"
        element={<FormularioAtualizacaoPage />}
      />
      
      {/* ==================== PORTAL DAS INSTITUIÇÕES ==================== */}
      {/* Portal Login */}
      <Route path="/portal/login" element={<PortalLoginPage />} />
      
      {/* Portal Recuperar Password */}
      <Route path="/portal/recuperar-password" element={<PortalRecuperarPasswordPage />} />
      
      {/* Portal Registar */}
      <Route path="/portal/registar" element={<PortalRegistarPage />} />
      
      {/* Portal Candidatura Submetida */}
      <Route 
        path="/portal/candidatura-submetida" 
        element={
          <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
            <div className="max-w-md text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-slate-900 mb-2">Candidatura Submetida!</h1>
              <p className="text-slate-600 mb-6">
                A sua candidatura foi recebida com sucesso. A nossa equipa irá analisar os dados (2-5 dias úteis).
                Receberá um email assim que a candidatura for aprovada.
              </p>
              <a href="/portal/login" className="inline-flex items-center px-4 py-2 bg-[#0066CC] text-white rounded-lg hover:bg-[#0055AA]">
                Voltar ao Login
              </a>
            </div>
          </div>
        } 
      />
      
      {/* Portal Protected Routes */}
      <Route path="/portal" element={<PortalLayout />}>
        <Route path="dashboard" element={<PortalDashboardHome />} />
        <Route path="instituicao" element={<PortalInstituicaoPage />} />
        <Route path="valencias" element={<PortalValenciasPage />} />
        <Route path="alterar-password" element={<PortalAlterarPasswordPage />} />
        {/* Placeholder routes for future implementation */}
        <Route path="pedidos" element={<PortalPedidosPage />} />
        <Route path="pedidos/novo" element={<PortalPedidosPage />} />
        <Route path="documentos" element={<PortalDocumentosPage />} />
        <Route path="relatorios" element={<PortalRelatoriosPage />} />
        <Route path="atualizacao/:campanhaId" element={<PortalAtualizacaoPage />} />
        <Route path="mensagens" element={<PortalMensagensPage />} />
        <Route path="voluntariado" element={<PortalVoluntariadoPage />} />
        <Route path="notificacoes" element={<PortalNotificacoesPage />} />
        <Route path="definicoes" element={<div className="p-6 text-center text-slate-500">Definições - Em desenvolvimento</div>} />
        <Route path="ajuda" element={<div className="p-6 text-center text-slate-500">Ajuda - Em desenvolvimento</div>} />
        <Route index element={<Navigate to="/portal/dashboard" replace />} />
      </Route>
      
      {/* Default Redirect - IMPORTANT: Must be after all specific routes */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
